<template>
  <label class="catalog__checkbox-label" :class="disabled ? 'catalog__checkbox-label-disabled' : ''"><!--
    --><input type="checkbox" autocomplete="off" :disabled="disabled" :checked="checked" @input="!disabled ? $emit('input', $event) : null"><!--
      --><div class="catalog__instead-checkbox"></div><!--
      --><span class="checkbox-text">{{ label }}</span><span v-if="hint" class="hint-text">{{ hint }}</span><!--
  --></label>
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    label: String,
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    },
    hint: {
      type: String,
      require: false
    }
  }
}
</script>